export default function (value, width) {
  if (!value) {
    return value
  }
  const result = value.toString()
  return result.length >= width ? result : new Array(width - result.length + 1).join('0') + result
}
